// extracted by mini-css-extract-plugin
export default {"footer":"FooterLight_footer__S0pvp","link":"FooterLight_link__uFc2g"};